import React, { useCallback, useLayoutEffect, useState } from 'react';
import PropTypes from 'prop-types';
import fp from 'lodash/fp';
import Checkbox from '../../../../webcommon/common/checkbox/Checkbox';
import classnames from 'classnames';
import Book from '../../../../webcommon/common/Icons/Book.svg';
import Unbook from '../../../../webcommon/common/Icons/Unbook.svg';
import Delete from '../../../../webcommon/common/Icons/Cross-Small.svg';
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';
import { noop } from 'lodash';
import defaultStyles from './TradeTable.module.scss';

const TradeTable = (props) => {
    const {
        setTradeChecked,
        viewTradeInPricingParams,
        trades,
        readOnly
    } = props;
    const checkboxOnChange = useCallback(
        name => e => setTradeChecked(e, name),
        [setTradeChecked]
    );

    // All of this is for memoizing the double click callback
    const [viewTradeInPricingParamsMemoisedList,
        setViewTradeInPricingParamsMemoisedList] = useState({});
    useLayoutEffect(
        () => {
            const newTradeMappingFunctions = fp.reduce(
                (acc, cur) => ({
                    ...acc, [cur.name]: () => viewTradeInPricingParams(cur, readOnly)
                }),
                {}
            )(trades);
            setViewTradeInPricingParamsMemoisedList(newTradeMappingFunctions);
        },
        [trades, viewTradeInPricingParams, readOnly]
    );

    return (
        <div className={ props.styles.tradePricedTodayBody }>
            <div className={ props.styles.tableHeader }>
                <div className={ props.styles.headerCheckbox }>
                    <Checkbox
                        checked={ props.tradeIdTicked }
                        onChange={ props.setTradeCheckedId }
                    />
                </div>
                Trade ID
            </div>

            <div className={ props.styles.tableBody }>
                <div className={ props.styles.bookedTrades }>
                    {props.trades.filter(trade => trade.booked).map(bookedTrade => (
                        <div
                            className={ props.styles.tableRow }
                            key={ bookedTrade.name }
                            onDoubleClick={ viewTradeInPricingParamsMemoisedList[bookedTrade.name] }
                        >
                            <div className={ props.styles.tableRowCheckbox }>
                                <Checkbox
                                    checked={ bookedTrade.selected }
                                    onChange={ noop }
                                    disabled
                                />
                            </div>
                            <div className={ props.styles.bookedBold }>
                                Booked -
                            </div>{bookedTrade.name}

                            <Tooltip
                                placement="left"
                                overlay="Cancel"
                                arrowContent={ <div className="rc-tooltip-arrow-inner" /> }
                            >
                                <div className={ props.styles.tradeTableButtonWrapper } href="#">
                                    <button
                                        onClick={ () => props.openUnbookTradesModal(bookedTrade) }
                                        className={ props.styles.tooltip }
                                        type="button"
                                    >
                                        <img
                                            alt="Cancel"
                                            src={ Unbook }
                                            className={ props.styles.svg }
                                        />
                                    </button>
                                </div>
                            </Tooltip>
                        </div>
                    ))}
                </div>

                {props.trades.filter(trade => !trade.booked).map((bookedTrade, index) => (
                    <div
                        className={ classnames({
                            [props.styles.tableRow]: true,
                            [props.styles.evenRow]: index % 2 === 0,
                            [props.styles.oddRow]: index % 2 !== 0
                        }) }
                        onDoubleClick={ viewTradeInPricingParamsMemoisedList[bookedTrade.name] }
                        key={ bookedTrade.name }
                    >
                        <div className={ props.styles.tableRowCheckbox }>
                            <Checkbox
                                checked={ bookedTrade.selected }
                                onChange={ checkboxOnChange(bookedTrade.name) }
                            />
                        </div>
                        <div>{bookedTrade.name}</div>
                        { !props.readOnly && (
                            <>
                                <Tooltip
                                    placement="left"
                                    overlay="Book"
                                    arrowContent={ <div className="rc-tooltip-arrow-inner" /> }
                                >
                                    <div className={ props.styles.tradeTableButtonWrapperSmall } href="#">
                                        <button onClick={ () => props.openBookTradesModal(bookedTrade) } className={ props.styles.tooltip } type="button">
                                            <img
                                                alt="Book"
                                                src={ Book }
                                                className={ props.styles.svg }
                                            />
                                        </button>
                                    </div>
                                </Tooltip>
                                <Tooltip
                                    placement="top"
                                    overlay="Delete"
                                    arrowContent={ <div className="rc-tooltip-arrow-inner" /> }
                                >
                                    <div className={ props.styles.deleteTradeButton } href="#">
                                        <button onClick={ () => props.openDeleteTradesModal(bookedTrade) } className={ props.styles.tooltip } type="button">
                                            <img
                                                alt="Delete"
                                                src={ Delete }
                                                className={ props.styles.svg }
                                            />
                                        </button>
                                    </div>
                                </Tooltip>
                            </>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

TradeTable.propTypes = {
    openBookTradesModal: PropTypes.func,
    openDeleteTradesModal: PropTypes.func,
    openUnbookTradesModal: PropTypes.func,
    tradeIdTicked: PropTypes.bool,
    trades: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            checked: PropTypes.bool,
            booked: PropTypes.bool
        })
    ),
    setTradeChecked: PropTypes.func.isRequired,
    setTradeCheckedId: PropTypes.func.isRequired,
    styles: PropTypes.objectOf(PropTypes.string),
    viewTradeInPricingParams: PropTypes.func,
    readOnly: PropTypes.bool
};

TradeTable.defaultProps = {
    openBookTradesModal: noop,
    openDeleteTradesModal: noop,
    openUnbookTradesModal: noop,
    tradeIdTicked: false,
    trades: [],
    styles: defaultStyles,
    viewTradeInPricingParams: noop,
    readOnly: false
};

export default TradeTable;
